<div class="form-group" [class.has-error]="showError">
  @if (props.label && to['hideLabel'] !== true) {
    <label [id]="id" [attr.for]="id + '_0'">
      {{ props.label }}
      @if (props.required && to['hideRequiredMarker'] !== true) {
        <span>*</span>
      }
    </label>
  }
  <ng-template #fieldComponent></ng-template>
  @if (showError) {
    <div class="invalid-feedback" [style.display]="'block'">
      <formly-validation-message [style.display]="'none'" #validationRef  [field]="field"></formly-validation-message>
      <!-- FD CHECK: <ng-container *ngIf="validationRef && validationRef.errorMessage"></ng-container> -->
      @if (validationRef) {
        {{ validationRef.errorMessage }}
      }
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
